<template>
  <svg
    id="Layer_1"
    data-name="Layer 1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 59.26 74.42"
  >
    <title>RCP</title>
    <path style="fill: #e5502c;" d="M53.57,67.14h-47V7.28h31l16,17.48Z" />
    <polygon
      style="fill: #fff;"
      points="48.89 62.46 11.21 62.46 11.21 11.96 32.24 11.96 32.24 27.11 48.89 27.18 48.89 62.46"
    />
    <text
      style="
        fill: #e5502c;
        font-size: 15.8px;
        font-family: GothamRounded-Bold, Gotham Rounded;
        font-weight: 700;
      "
      transform="translate(13.23 48.26)"
    >
      RCP
    </text>
  </svg>
</template>

<script>
export default {
    name: 'RCP'
}
</script>